// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1BAZz","errors":"Errors_errors__6P7QQ"};